'use strict';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from '../../utils/get';
import { continueWatchingItemsSelector } from '../../reducers/continueWatching';
import SimilarVideoContent from './SimilarVideoContent.js';

class SimilarVideoContentContainer extends Component {
    render() {
        const { contentList, continueWatchingItems, titleArticleId, isTitlePage } = this.props;
        const filteredContentList = contentList.items.filter(({ item }) => {
            return !continueWatchingItems.find((watchedItem) => {
                const watchedTitleId = watchedItem.get('titleArticleId');

                return String(watchedTitleId) === item.id;
            });
        });

        const listTracking = {
            listID: get(contentList, 'analyticsIdentifiers.listId'),
            listType: get(contentList, 'analyticsIdentifiers.listType'),
        };

        return (
            <SimilarVideoContent
                key={titleArticleId}
                headerText={contentList.name}
                listContent={filteredContentList}
                titleArticleId={titleArticleId}
                isTitlePage={isTitlePage}
                listTracking={listTracking}
            />
        );
    }
}

SimilarVideoContent.propTypes = {
    titleArticleId: PropTypes.string,
    isTitlePage: PropTypes.bool,
    contentList: PropTypes.array,
};

const mapStateToProps = (state) => {
    return {
        continueWatchingItems: continueWatchingItemsSelector(state),
    };
};

export default connect(mapStateToProps)(SimilarVideoContentContainer);
